import { isChargerConnectivity, type ChargerConnectivity } from '@evi/shared';
import type { SubmissionInvitePrefill } from '@/lib/api';

/**
 * The connectivity choice the invited form starts with on a needs_info
 * resubmit: the deployment's recorded choice, which the submitter can still
 * change. A deployment registered before the choice existed (null, absent
 * from an older Api, or an unknown value) starts empty, and the required
 * choice must be picked before the form submits.
 *
 * Pure so InvitedSubmissionPage's seeding is testable without rendering;
 * pinned by invitedSubmissionPrefill.test.ts.
 */
export function prefillConnectivity(
  prefill: Pick<SubmissionInvitePrefill, 'connectivity'> | null | undefined,
): ChargerConnectivity | '' {
  return prefill && isChargerConnectivity(prefill.connectivity) ? prefill.connectivity : '';
}
